<div class="header">
  <div class="header-actions" *ngIf="!isLoading">
    <div class="search-filter-container">
    </div>
    <div class="actions-container">
      <txp-button (click)="deleteDayparts()"
                  *ngIf="false"
                  [style]="buttonStyle.SECONDARY"
                  [size]="buttonSize.SMALL"
                  [disabled]="selection.selected.length === 0 || !dataSource.data.length"
                  data-qa-label="DeleteButton">
        {{ 'menu.information.dayParts.deleteBtn' | translate }}
      </txp-button>
      <txp-button data-qa-label="CreateDaypartButton"
                  [style]="buttonStyle.PRIMARY"
                  [size]="buttonSize.SMALL"
                  [disabled]="!canAddDaypart"
                  (click)="createDaypart()">
        {{ (isStoreLevel ? 'store.dayparts.addDayPartBtn' : 'menu.information.dayParts.configureDayPartBtn') | translate }}
      </txp-button>
    </div>
  </div>
</div>

<txp-loading [color]="loadingColor.COLOR" *ngIf="isLoading"></txp-loading>

<div class="messages">
  <txp-message [type]="messageType.DANGER"
               *ngIf="showError">
        {{ 'brand.aggregator.loadDataErrorMsg' | translate }}
  </txp-message>
  <txp-message [type]="messageType.WARNING"
               *ngIf="isStoreLevel && !isLoading && !hasBrandDayparts">
        {{ 'store.dayparts.noBrandDaypartsMsg' | translate }}
  </txp-message>
  <txp-message [type]="messageType.WARNING"
               *ngIf="isStoreLevel && !isLoading && hasBrandDayparts && !canAddDaypart">
        {{ 'store.dayparts.allDaypartsConfiguredMsg' | translate }}
  </txp-message>
</div>

<div class="table-content" [hidden]="isLoading">
  <table mat-table
         [dataSource]="dataSource"
         matSort
         matSortActive="dayPartName"
         matSortDirection="asc"
         matSortDisableClear>
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef [hidden]="readOnly">
        <mat-checkbox (change)="$event ? masterToggle() : null"
                      [checked]="selection.hasValue() && isAllSelected()"
                      [indeterminate]="selection.hasValue() && !isAllSelected()"
                      data-qa-label="MasterToggleCheckBox">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row" [hidden]="readOnly">
        <mat-checkbox (click)="$event.stopPropagation()"
                      (change)="$event ? selection.toggle(row) : null"
                      [checked]="selection.isSelected(row)"
                      data-qa-label="MenuRowCheckBox">
        </mat-checkbox>
      </td>
    </ng-container>
    <ng-container matColumnDef="dayPartName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="dayPartName">
        {{ 'menu.information.dayParts.title' | translate }}
      </th>
      <td mat-cell *matCellDef="let dayPart">
        <ng-container *ngIf="readOnly">
          {{ dayPart.dayPartName }}
        </ng-container>
        <ng-container *ngIf="!readOnly">
          <a class="edit-link"
            (click)="createDaypart(dayPart.id)"
            [attr.title]="'form.button.edit' | translate"
            data-qa-label="EditLink"
            href="javascript:void(0);">
            {{ dayPart.dayPartName }}
          </a>
        </ng-container>
      </td>
    </ng-container>
    <ng-container *ngIf="isStoreLevel || isMenuLevel" matColumnDef="hours">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="hours">
        {{ 'menu.information.dayParts.hours' | translate }}
      </th>
      <td mat-cell *matCellDef="let dayPart">
        {{ dayPart.hoursString }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="(isStoreLevel || isMenuLevel) ? ['select', 'dayPartName', 'hours'] : ['select', 'dayPartName']; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: (isStoreLevel || isMenuLevel) ? ['select', 'dayPartName', 'hours'] : ['select', 'dayPartName']"></tr>
  </table>
</div>
